import { useTranslation } from "react-i18next";

export default function FinalCTA() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-24 relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20wide%20cinematic%20banner%20of%20a%20carefully%20curated%20shopping%20haul%20featuring%20multiple%20shoe%20boxes%20clothing%20bags%20and%20accessory%20boxes%20arranged%20in%20a%20pleasing%20grid%20on%20a%20warm%20terracotta%20and%20cream%20textured%20background%2C%20soft%20glowing%20light%2C%20premium%20unboxing%20aesthetic%2C%20inviting%20warm%20tones%2C%20generous%20negative%20space%20at%20center&width=1600&height=800&seq=final-cta-bg&orientation=landscape&nocache=true"
          alt="CSSBuy Spreadsheet Collection"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/50" />
      </div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-2xl md:text-4xl font-bold text-white mb-4">
          {t("home.finalCta.title")}
        </h2>
        <p className="text-white/80 text-lg mb-8">{t("home.finalCta.content")}</p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-white text-gray-900 font-semibold rounded-lg hover:bg-gray-100 transition-colors"
          >
            <i className="ri-external-link-line" />
            {t("home.finalCta.cta")}
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-emerald-700 text-white font-semibold rounded-lg hover:bg-emerald-800 transition-colors"
          >
            <i className="ri-shopping-bag-line" />
            {t("home.finalCta.secondary")}
          </a>
        </div>
      </div>
    </section>
  );
}